import { authBasePart, identityBasePart } from "./constants";

export default {
  authorize: (redirectUrl: string) =>
    `${authBasePart}/authorize?redirectUrl=${redirectUrl}`,
  renewAccessToken: () => `${authBasePart}/token`,
  logout: () => `${identityBasePart}/logout`,
  userSession: () => `${authBasePart}/user-session`,
  isAuthenticated: () => `${authBasePart}/is-authenticated`,
};
